import { render, staticRenderFns } from "./class-details.vue?vue&type=template&id=7d49d564&scoped=true"
import script from "./class-details.vue?vue&type=script&lang=js"
export * from "./class-details.vue?vue&type=script&lang=js"
import style0 from "./class-details.vue?vue&type=style&index=0&id=7d49d564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49d564",
  null
  
)

export default component.exports